import PropTypes from 'prop-types';

export const payableInfo = PropTypes.shape({
  name: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  zipCode: PropTypes.string
});
